export default {"src":"/_next/static/media/logo.7d5562a9.svg","height":24,"width":106,"blurWidth":0,"blurHeight":0};